import React from 'react';
import moment from 'moment';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { rgba, scssVariables, scssVariables as variables } from 'src/helpers';
import { MCButton, PopoverMenu } from 'src/components/basic';

class MonthSelector extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      y: moment(this.props.selectedDay).year()
    };
  }

  getMonths = () => {
    let { minDate = 0 } = this.props;
    return moment
      .months()
      .map((month) => {
        return moment(`${this.state.y} ${month} 01`, 'YYYY MMMM DD').valueOf();
      })
      .filter((month) => month >= minDate);
  };

  render() {
    let { minDate = 0, selectedDay: d, onChange } = this.props;
    let minYear = moment(minDate).format('Y') * 1;
    let prevYear = this.state.y - 1;
    let nextYear = this.state.y + 1;
    const selectedDay = moment(d);
    return (
      <PopoverMenu
        placement={'bottom-end'}
        triggerOffset={10}
        popupMenuStyle={{ backgroundColor: 'white' }}
        style={{ display: 'flex', alignItems: 'center' }}
        menu={(close) => (
          <div className={'mc-datepicker'}>
            <div className={'mc-datepicker-month'} style={{ alignItems: 'center' }}>
              <MCButton
                iconname={BASE_ICONS.LEFT}
                primary
                width={30}
                light
                radius
                type={'button'}
                onClick={() => this.setState({ y: prevYear })}
                disabled={prevYear < minYear}
              />
              <div className={'mc-month-title'} style={{ flex: 1 }}>
                {this.state.y}
              </div>
              <MCButton
                iconname={BASE_ICONS.RIGHT}
                primary
                width={30}
                light
                radius
                type={'button'}
                onClick={() => this.setState({ y: nextYear })}
                disabled={prevYear < minYear}
              />
            </div>
            <div className={' mc-bb'} />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', padding: 30 }}>
              {this.getMonths().map((month) => {
                let curMonth = moment(month).format('MMMM, YYYY');
                let selected = curMonth === selectedDay.format('MMMM, YYYY');
                return (
                  <button
                    key={month}
                    className={'mc-no-style-btn mc-value-516'}
                    type={'button'}
                    onClick={() => {
                      onChange && onChange(month);
                      close();
                    }}
                    style={{
                      textAlign: 'center',
                      paddingTop: 10,
                      paddingBottom: 10,
                      paddingLeft: 21,
                      paddingRight: 21,
                      ...(selected
                        ? {
                            backgroundColor: rgba(variables['colors-mc-primary'], 0.05),
                            color: variables['colors-mc-primary']
                          }
                        : {})
                    }}
                  >
                    {moment(month).format('MMMM')}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      >
        {(isOpen) => (
          <div className={'mc-no-style-btn mc-flex'}>
            <span className={'mc-label-518'}>{selectedDay.format('MMMM, YYYY')}</span>
            <SVGIcon
              padding={5}
              iconname={isOpen ? BASE_ICONS.UP : BASE_ICONS.DOWN}
              width={30}
              fill={scssVariables['colors-mc-text-light']}
            />
          </div>
        )}
      </PopoverMenu>
    );
  }
}

export default MonthSelector;
